import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { DATABASE_URL } from "../config/globals";

type User = {
  displayName: string;
  email?: string;
  [key: string]: any;
};


function NavBar() {
  const [user, setUser] = useState<User | null>(null);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    fetch(DATABASE_URL+"/auth/user", { credentials: "include" })
      .then((res) => res.json())
      .then((data) => {
        if (data) {
          setUser(data);
        } else {
          setUser(null);
        }
      })
      .catch(() => setUser(null));
  }, []);

  const handleLogin = () => {
    window.location.href = DATABASE_URL+"/auth/google";
  };

  const handleLogout = () => {
    window.location.href = DATABASE_URL+"/auth/logout";
  };

  return (
      <nav aria-label="Global" className="flex flex-wrap items-center lg:px-8">
        <div className="flex lg:flex-1">
          <Link to="/" className="-m-1.5 p-1.5">
            <span className="sr-only">FindFish</span>
            <img className="h-8 w-auto" src="https://emojipedia.org/_next/image?url=https%3A%2F%2Fis.zobj.net%2Fimage-server%2Fv1%2Fimages%3Fr%3DBpqhUvOVyp-exgGRNwPP6Gdq9aHnryMhmTBVqL3l9_RxF0QVSvPcGJvHD_KQlchuGUeUq6juvaaDWVEFB-9lyude0WRbIyyV_d7FOsGNaeDDDmxwYzb4x8kmgtU46bPo-2iQyFg7ZHL6c9JebbKnlv5ymhcAWbb9ywGX-TAhOkqissj9MMeIeRbe_gNi2mfoPMaoKlnatHazqe9ESVGfYtOPv6Vz6FP1l8Ng_cJI4pBeWru53hNI9SjmEJQ&w=256&q=75" alt=""/>
            <Link to="/" className="text-2xl font-semibold">FindFish</Link>
          </Link>
        </div>
        <div className="flex lg:hidden">
          <button type="button" onClick={() => setMenuOpen(!menuOpen)} className="-m-2.5 inline-flex items-center justify-center rounded-md p-6">
            <span className="sr-only">Open main menu</span>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" data-slot="icon" aria-hidden="true" className="size-6">
              <path d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </button>
        </div>
        <div className="hidden lg:flex lg:gap-x-24">
          <Link to="/" className="text-2xl font-semibold">Fish Finder Map</Link>
          <Link to="/upload" className="text-2xl font-semibold">Upload Fish</Link>
          {/* <Link to="/ai" className="text-2xl font-semibold">AI Identifier</Link> */}
          <Link to="/about" className="text-2xl font-semibold">About</Link>
        </div>

      {menuOpen && (
        <div className="w-full bg-gray-900 text-white flex flex-col items-left py-4 space-y-4 lg:hidden">
          <Link to="/" onClick={() => setMenuOpen(false)}>Fish Finder Map</Link>
          <Link to="/upload" onClick={() => setMenuOpen(false)}>Upload Fish</Link>
          <Link to="/about" onClick={() => setMenuOpen(false)}>About</Link>
        </div>
      )}

        <div className="hidden lg:flex lg:flex-1 lg:justify-end items-center">
          {user ? (
            <>
              <img
                src={user.photo}
                alt={user.displayName}
                style={{ width: 30, height: 30, borderRadius: "50%" }}
              />
              <div className="p-2">
                {user.displayName}
              </div>
              
                <button onClick={handleLogout} type="button" className="text-white bg-red-800 hover:bg-red-950 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                Logout
                <svg className= "w-3.5 h-3.5 ms-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 10">
                  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 5h12m0 0L9 1m4 4L9 9"/>
                </svg>
              </button>
            </>
          ) : (
            <button onClick={handleLogin} className="justify-left">
              <img 
                src="https://developers.google.com/static/identity/images/branding_guideline_sample_dk_rd_lg.svg" 
                alt="Google logo" 
              />
            </button>
          )}
        </div>
      </nav>
  );
}

export default NavBar;
